// extracted by mini-css-extract-plugin
export default {"root":"trial-notification_root__NDwEi","text":"trial-notification_text__vli0I","link":"trial-notification_link__U+xjO","icon":"trial-notification_icon__-NOB4"};